import { useEffect } from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import RegistrationForm from './RegistrationForm'
import Header from './Header'
import Footer from './Footer'

const theme = createTheme()

function App () {
  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'user_entry_source', source: document.referrer })
  }, [])
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <RegistrationForm />
      <Footer />
    </ThemeProvider>
  )
}

export default App
